<template>
  <s-filter
    :active="!!(model.start || model.end)"
    :label="label"
    :active-label="activeLabel"
    :value="formatDateRange(model.start, model.end)"
    @clear="model = {start: undefined, end: undefined}"
  >
    <template #default="{close}">
      <s-date-range-filter-content v-model="model" @close="close" :labelStyle />
    </template>
  </s-filter>
</template>
<script setup lang="ts">
import SDateRangeFilterContent from '../SDateRangeFilterContent.vue';
import SFilter from '../SFilter.vue';
import {monthDaySometimesYear} from '../../format/dates';
import {useI18n} from 'vue-i18n';

type DateRange = {
  start?: string | null;
  end?: string | null;
};

type LabelStyle = 'after-before' | 'from-to';

const {labelStyle = 'from-to'} = defineProps<{
  label: string;
  activeLabel?: string;
  labelStyle?: LabelStyle;
}>();

const model = defineModel<DateRange>({default: {start: '', end: ''}});

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

function formatDateRange(from?: string | null, to?: string | null): string {
  if (from && to) {
    return t(labelStyle + '.fromXToY', {
      from: monthDaySometimesYear(from),
      to: monthDaySometimesYear(to),
    });
  } else if (from) {
    return t(labelStyle + '.fromX', {from: monthDaySometimesYear(from)});
  } else if (to) {
    return t(labelStyle + '.untilY', {to: monthDaySometimesYear(to)});
  }
  return '';
}
</script>
<i18n>
{
  "en": {
    "after-before": {
      "fromXToY": "{from} - {to}",
      "fromX": "After {from}",
      "untilY": "Before {to}"
    },
    "from-to": {
      "fromXUntilY": "{from} - {to}",
      "fromX": "From {from}",
      "untilY": "Until {to}"
    }
  },
  "fr": {
    "after-before": {
      "fromXToY": "{from} - {to}",
      "fromX": "Après {from}",
      "untilY": "Avant {to}"
    },
    "from-to": {
      "fromXUntilY": "{from} - {to}",
      "fromX": "De {from}",
      "untilY": "Jusqu'à {to}"
    }
  }
}
</i18n>
